import { useTranslation } from '@frontend/i18n';
import { usePopoverMenu } from '@frontend/design-system';
import { InboxTaskStatus } from '../../../types';
import { InboxFiltersPopoverSubmenuItem } from '../inbox-filters-popover-submenu-item';
import { TasksFilterPopoverMenu } from './tasks-filter-popover';

type TasksFilterPopoverSubmenuItemProps = {
  toggleItems: (taskStatuses: InboxTaskStatus[]) => void;
  selectedTasks: InboxTaskStatus[];
  groupIds?: string[];
  divider?: 'top' | 'bottom';
  trackingId?: string;
};

export const TasksFilterPopoverSubmenuItem = ({
  toggleItems,
  selectedTasks,
  groupIds,
  divider,
  trackingId,
}: TasksFilterPopoverSubmenuItemProps) => {
  const { t } = useTranslation('inbox');
  const tasksPopover = usePopoverMenu<HTMLButtonElement>({
    placement: 'right-start',
    middlewareOptions: {
      offset: {
        mainAxis: 0,
        crossAxis: -8,
      },
    },
  });

  return (
    <>
      <InboxFiltersPopoverSubmenuItem
        getSubmenuTriggerProps={tasksPopover.getTriggerProps}
        iconName='task-small'
        label={t('Tasks')}
        count={selectedTasks.length}
        divider={divider}
        trackingId={trackingId}
      />
      <TasksFilterPopoverMenu
        getMenuProps={tasksPopover.getMenuProps}
        getItemProps={tasksPopover.getItemProps}
        groupIds={groupIds}
        toggleItems={toggleItems}
        selectedTasks={selectedTasks}
      />
    </>
  );
};
